import React, { FunctionComponent } from 'react';

import Text from 'components/Text/Text';
import { toastMotionProps } from 'utils/styles/animations';
import { ColorNames } from 'utils/styles/theme';

import * as S from './Toast.styles';

export interface ToastProps {
  text: string;
  variant?: 'default' | 'dark';
}

const defaultProps: Partial<ToastProps> = {
  text: 'Toast',
  variant: 'default',
};

const Toast: FunctionComponent<ToastProps> = ({ text, variant, ...rest }) => {
  const isDark = variant === 'dark';

  return (
    <S.ToastWrapper {...rest}>
      <S.Container {...toastMotionProps} $variant={variant}>
        <Text
          as="span"
          size="small"
          text={text}
          color={isDark ? ColorNames.white : ColorNames.black}
        />
      </S.Container>
    </S.ToastWrapper>
  );
};

Toast.defaultProps = defaultProps;

export default Toast;
